import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import type { ReactNode } from "react";
import type { LoadingStatus } from "app/UtilitiesAndConstants/types/loadingStatus";

type Props = {
    status: LoadingStatus;
    children: NonNullable<ReactNode>;
};

const StatefullCell = ({ status, children }: Props) => {
    switch (status) {
        case "success":
            return children;

        case "error":
            return "N/A";

        case "loading":
        default:
            return (
                <PixelPlaceholderLoader
                    width={44}
                    height={14}
                />
            );
    }
};

export default StatefullCell;
